module.exports = __webpack_public_path__ + "img/icon_infor3@3x.d8aecb0d.png";